import {Action, handleActions} from "redux-actions";
import {none, option} from "ts-option";
import {AssetSearchMap, AssetState} from "./AssetState";
import {ASSET_CREATED, ASSET_FETCHED, ASSET_UPDATED, ASSETS_SEARCH_FETCHED} from "../../action/asset/actionType";
import {ASSET_ATTRIBUTES_FETCHED} from "../../action/assetAttribute/actionType";
import AssetSearch from "../../../model/asset/AssetSearch";

const initState: AssetState = {
	assets: {},
	assetAttributes: none,
	assetSearchMap: {}
};

const reducer = handleActions({
	[ASSET_FETCHED]: (state: AssetState, action: Action<any>): AssetState => {
		return addAssetToState(state, action)
	},
	[ASSET_CREATED]: (state: AssetState, action: Action<ASSET_CREATED>): AssetState => {
		return addAssetToState(state, action)
	},
	[ASSET_UPDATED]: (state: AssetState, action: Action<ASSET_UPDATED>): AssetState => {
		return addAssetToState(state, action)
	},
	[ASSET_ATTRIBUTES_FETCHED]: (state: AssetState, action: Action<ASSET_ATTRIBUTES_FETCHED>): AssetState => {
		return {...state, assetAttributes: option(action.payload.assetAttributes)}
	},
	[ASSETS_SEARCH_FETCHED]: (state: AssetState, action: Action<ASSETS_SEARCH_FETCHED>): AssetState => {
		const assetsMap = action.payload.assets.reduce((obj: AssetSearchMap, item: AssetSearch) => {
			obj[item.id] = item;
			return obj
		}, {})
		return {...state, assetSearchMap: {...state.assetSearchMap, ...assetsMap}}
	},
}, initState);

const addAssetToState = (state: AssetState, action: Action<ASSET_CREATED | ASSET_UPDATED | ASSET_FETCHED>) => {
	const assets = {...state.assets, [action.payload.asset.id]: action.payload.asset}
	const assetSearchMap = {...state.assetSearchMap, [action.payload.asset.id]: action.payload.asset.toAssetSearch()}
	return {...state, assets, assetSearchMap}
}

export default reducer;